export const bannerCategoryValues = {
  english: 'FOREIGN',
  money: 'MONEY',
  career: 'CAREER',
  hobby: 'HOBBY'
}
